import type { DraftType } from '@/features/events/conversation/state/types'

interface DraftDialogConfig {
  readonly title: string
  readonly placeholder: string
  readonly description: string
  readonly submitButtonLabel: string
  readonly submitButtonLoadingLabel: string
}

const DRAFT_DIALOG_CONFIG: Record<DraftType, DraftDialogConfig> = {
  user_reply: {
    title: 'Reply to Agent',
    placeholder: 'Enter your reply to Claude Code...',
    description: "Reply to Claude Code's request for input.",
    submitButtonLabel: 'Reply',
    submitButtonLoadingLabel: 'Replying...',
  },
  injected_prompt: {
    title: 'Inject Prompt',
    placeholder: 'Enter additional instructions or context for Claude Code...',
    description: 'This will inject your prompt into the current conversation.',
    submitButtonLabel: 'Inject',
    submitButtonLoadingLabel: 'Injecting...',
  },
  custom_option: {
    title: 'Custom Response',
    placeholder: 'Explain what you want Claude Code to do differently...',
    description: 'Provide custom instructions for this request.',
    submitButtonLabel: 'Submit',
    submitButtonLoadingLabel: 'Submitting...',
  },
  custom_answer: {
    title: 'Custom Answer',
    placeholder: 'Type your custom answer...',
    description: 'Provide your custom answer to this question.',
    submitButtonLabel: 'Save Answer',
    submitButtonLoadingLabel: 'Saving...',
  },
  resume_session: {
    title: 'Resume Session',
    placeholder: 'Leave empty to receive an automatic summary of where things left off.',
    description:
      'This will resume the session with your message, or generate an automatic summary if left empty.',
    submitButtonLabel: 'Resume',
    submitButtonLoadingLabel: 'Resuming...',
  },
}

export type { DraftDialogConfig }
export { DRAFT_DIALOG_CONFIG }
